import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";

import { Languages, AudioClipVoice, allAudioClipVoices } from "../models";

import MenuItem from "@material-ui/core/MenuItem";

export interface LanguageDropdownProps extends React.Props<any> {
    label: string;
    disabled?: boolean;
    intialLanguage?: AudioClipVoice;
    onChange: (language: AudioClipVoice) => void;
}

@observer
export default class LanguageDropdown extends React.Component<LanguageDropdownProps> {
    @observable private languageType: AudioClipVoice = AudioClipVoice.ENGLISH_US;

    constructor(props: LanguageDropdownProps) {
        super(props);
        if (props.intialLanguage) {
            this.languageType = props.intialLanguage;
        }
    }

    render() {
        return (
            <FormControl>
                <InputLabel>{this.props.label}</InputLabel>
                <Select
                    disabled={this.props.disabled}
                    style={{ minWidth: 230 }}
                    value={this.languageType}
                    input={<Input id="language1" />}
                    onChange={this.handleLanguageChange}
                >
                    {this.renderLanguageMenuItems()}
                </Select>
            </FormControl>
        );
    }

    @action
    private handleLanguageChange = (event: any) => {
        this.languageType = event.target.value;
        this.props.onChange(this.languageType);
    };

    private renderLanguageMenuItems() {
        let languages = [];
        for (var voice of allAudioClipVoices) {
            languages.push(Languages.getFriendlyString(voice));
        }
        languages.push(Languages.getFriendlyString(AudioClipVoice.OTHER));

        return languages.map((element, index) => (
            <MenuItem value={index === allAudioClipVoices.length ? "" : allAudioClipVoices[index]} key={index}>
                {element}
            </MenuItem>
        ));
    }
}
